import { render, staticRenderFns } from "./TierRow.vue?vue&type=template&id=c202b49e&"
import script from "./TierRow.vue?vue&type=script&lang=js&"
export * from "./TierRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports